import Service from '@/utils/request';


/**
* 获取配送站或者收货站列表
*
* @param params 请求参数对象
* @returns Promise<any> 包含站点列表的Promise对象
*/
export const fetchSiteList = (params) => Service.get('/biz/delivery/site/list', {
        params: {
            status:0,
            ...params,
            appCode: 'WL',
            
        },
    });
    /**
     * 获取配送站的收货站点列表
     * @param {*} params 
     * @returns 
     */
export const fetchServiceSiteList = (siteId) => Service.get('/biz/delivery/site/serviceSiteList', {
        params: {
            id: siteId,
            appCode: 'WL',
        },
    });
/**
 * 获取配送站或者收货站详情
 * @param {*} siteId 配送站或者收货站ID
 * @returns 
 */
export const fetchServiceSiteInfo = (siteId) => Service.get(`/biz/delivery/site/${siteId}`, {
        params: {
            appCode: 'WL',
        },
    });

    /**
     * 配送站统计数据
     * @param {siteId:配送站ID ，beginTime:开始时间，endTime:结束时间} params 
     * @returns 
     */
export const fetchSiteStatics = (params) => Service.get('/biz/delivery/site/deliveryOrderData', {
        params: {
            ...params,
            appCode: 'WL',
        },
    });
/**
 * 获取站点所有收货站的统计数据
 * 
 * @param {Object} siteId - 配送站ID
 * @param {string} 
 * @returns {Promise} 返回包含站点订单统计数据的Promise对象
 */
export const fetchSiteAllStatistics= (siteId) => Service.get('/biz/delivery/site/allTakeOrderData', {
        params: {
            siteId,
            appCode: 'WL',
        },
    });
/**
 * 获取配送站的摄像头列表
 * @param {*} 
 * @returns 
 */
export const fetchSiteCameras= (siteId) => Service.get('/biz/delivery/site/cameras', {
        params: {
        
            appCode: 'WL',
        },
    });

export default {
  fetchSiteList,
  fetchServiceSiteList,
  fetchSiteStatics,
  fetchSiteAllStatistics,
  fetchServiceSiteInfo,
  fetchSiteCameras
};